import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID
};

// Suppress specific Firebase Auth warnings
const originalConsoleError = console.error;
console.error = (...args) => {
    // Skip if no arguments or first arg isn't a string
    if (!args.length || typeof args[0] !== 'string') {
        originalConsoleError.apply(console, args);
        return;
    }

    // List of warning messages to suppress
    const suppressPatterns = [
        'INTERNAL ASSERTION FAILED: Expected a class definition',
        'Persistence setting failed',
        'Cross-Origin-Opener-Policy policy would block the window.closed call',
        'Cross-Origin-Opener-Policy policy would block the window.close call'
    ];

    // Check if the error message matches any of our suppression patterns
    if (suppressPatterns.some(pattern => args[0].includes(pattern))) {
        // Optionally log suppressed warnings in development
        if (
            import.meta.env.DEV) {
            console.debug('Suppressed Firebase warning:', args[0]);
        }
        return;
    }

    // Pass through all other errors
    originalConsoleError.apply(console, args);
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

export default app;